<script lang="ts">
  import LegalLayout from "./LegalLayout.svelte";
</script>

<LegalLayout title="Privacy Policy" effective="27 May 2026">
  <p>
    This Privacy Policy explains how Optioway ("we", "us") collects, uses, and protects your personal
    information when you use our desktop application and related cloud services (the "Service"). We
    only collect what we need to provide and improve the Service.
  </p>

  <h2>1. Information we collect</h2>
  <ul>
    <li>
      <strong>Account information</strong> — your name and email address, provided through our identity
      provider when you sign in.
    </li>
    <li>
      <strong>Subscription and billing information</strong> — your plan, subscription status, and a transaction
      reference. Payment card details are collected and stored by Paddle, not by us.
    </li>
    <li>
      <strong>Usage information</strong> — limited technical and usage data (such as feature usage and
      credit consumption) needed to operate the Service and enforce plan limits.
    </li>
    <li>
      <strong>Content you provide</strong> — the data, prompts, and context you choose to send to the
      Service so the agent can act on your behalf.
    </li>
  </ul>

  <h2>2. How we use information</h2>
  <ul>
    <li>to provide, maintain, and secure the Service;</li>
    <li>to manage your account, subscription, and access to paid features;</li>
    <li>to respond to your requests and provide support; and</li>
    <li>to comply with legal obligations.</li>
  </ul>

  <h2>3. Payments</h2>
  <p>
    Payments are processed by our Merchant of Record,
    <a href="https://www.paddle.com" target="_blank" rel="noopener noreferrer">Paddle.com</a>.
    Paddle collects and processes your payment information under its own
    <a href="https://www.paddle.com/legal/privacy" target="_blank" rel="noopener noreferrer"
      >privacy policy</a
    >. We do not receive or store your full payment card details.
  </p>

  <h2>4. How we share information</h2>
  <p>We do not sell your personal information. We share it only with:</p>
  <ul>
    <li><strong>Paddle</strong>, to process payments and manage subscriptions;</li>
    <li>
      <strong>service providers</strong> (such as identity, hosting, and AI model providers) who process
      data on our behalf under appropriate confidentiality obligations; and
    </li>
    <li><strong>authorities</strong>, where required by law.</li>
  </ul>

  <h2>5. Data retention</h2>
  <p>
    We keep personal information for as long as your account is active and as needed to provide the
    Service, then delete or anonymise it unless we are required to retain it for legal, accounting,
    or security purposes.
  </p>

  <h2>6. Your rights</h2>
  <p>
    Subject to applicable law, you may request access to, correction of, or deletion of your
    personal information, and you may object to or restrict certain processing. To make a request,
    contact us using the details below.
  </p>

  <h2>7. Cookies and local storage</h2>
  <p>
    The Service uses browser local storage and similar technologies that are strictly necessary to
    keep you signed in and remember your preferences. We do not use them for advertising.
  </p>

  <h2>8. Security</h2>
  <p>
    We use reasonable technical and organisational measures to protect your information. No method
    of transmission or storage is completely secure, so we cannot guarantee absolute security.
  </p>

  <h2>9. Changes to this policy</h2>
  <p>
    We may update this policy from time to time. When we make material changes, we will update the
    "Last updated" date above.
  </p>

  <h2>10. Contact</h2>
  <p>
    For privacy questions or to exercise your rights, contact us at
    <a href="mailto:info@optioway.com">info@optioway.com</a>.
  </p>
</LegalLayout>
